import { $hasFeature } from '@/core/utils/VueAcl'

/**
 * Resolve a human-readable label for a user-profile object — mirrors the label
 * expression used by the user-profile dropdown in PreviewContentUserProfileTab.
 *
 * Fallback order matches that dropdown so the label shown in the dialog
 * description is the same string the operator just selected:
 *   email → customer_id (when feature enabled) → user_id → id (UUID)
 *
 * Returns null when the profile is missing or has no usable identifier so
 * callers can render a no-profile-selected state instead of an empty string.
 *
 * @param {object|null|undefined} profile
 * @returns {string|null}
 */
export function getProfileLabel(profile) {
  if (!profile) {
    return null
  }
  if (profile.email) {
    return profile.email
  }
  if ($hasFeature('customerIdEnabled') && profile.customer_id) {
    return profile.customer_id
  }
  if (profile.user_id) {
    return profile.user_id
  }
  if (profile.id) {
    return profile.id
  }
  return null
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/helpers/ProfileLabelHelper.js